import { ClientAddressType, CreateClientAddressDto } from "@/lib/api";

/** "Usar o mesmo endereço para entrega" só vale no cadastro de um endereço de cobrança, com a opção ligada na tela. */
export const shouldCopyToShipping = ({
  enabled,
  isEditing,
  addressType,
  checked,
}: {
  enabled: boolean;
  isEditing: boolean;
  addressType: ClientAddressType;
  checked: boolean;
}): boolean => enabled && !isEditing && addressType === "Billing" && checked;

/** Endereço de entrega com os mesmos dados do de cobrança (inclusive se vira padrão). */
export const buildShippingCopy = (billing: CreateClientAddressDto): CreateClientAddressDto => ({
  ...billing,
  addressType: "Shipping",
});
